import { useState, useEffect, useRef } from "react";

const useTooltipLogic = () => {
  const [tooltip, setTooltip] = useState({ visible: false, text: "", x: 0, y: 0 });
  const tableContainerRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const updateTooltipPosition = () => {
      if (tooltip.visible && tooltipRef.current && tableContainerRef.current) {
        const targetElement = tooltipRef.current.targetElement;
        if (targetElement) {
          const rect = targetElement.getBoundingClientRect();
          const containerRect = tableContainerRef.current.getBoundingClientRect();
          const scrollX = tableContainerRef.current.scrollLeft;
          const scrollY = window.scrollY || window.pageYOffset;

          const tempTooltip = document.createElement("div");
          tempTooltip.style.visibility = "hidden";
          tempTooltip.style.position = "absolute";
          tempTooltip.innerHTML = tooltip.text?.replace(/\n/g, "<br/>");
          tempTooltip.style.padding = "5px 10px";
          document.body.appendChild(tempTooltip);
          const tooltipWidth = tempTooltip.offsetWidth;
          const tooltipHeight = tempTooltip.offsetHeight;
          document.body.removeChild(tempTooltip);

          let x = rect.left - containerRect.left + scrollX + rect.width + 10;
          let y = rect.top - containerRect.top + (rect.height - tooltipHeight) / 2;

          const containerWidth = tableContainerRef.current.offsetWidth;
          const windowHeight = window.innerHeight;

          if (x + tooltipWidth > containerWidth) {
            x = rect.left - containerRect.left + scrollX - tooltipWidth - 10;
          }
          if (y + tooltipHeight > windowHeight + scrollY) {
            y = windowHeight + scrollY - tooltipHeight - 10;
          }
          if (y < 0) y = 10;

          setTooltip((prev) => ({ ...prev, x, y }));
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", updateTooltipPosition);
      window.addEventListener("scroll", updateTooltipPosition);
      return () => {
        container.removeEventListener("scroll", updateTooltipPosition);
        window.removeEventListener("scroll", updateTooltipPosition);
      };
    }
  }, [tooltip.visible]);

  const handleMouseEnter = (event, text) => {
    const targetElement = event.currentTarget;
    const rect = targetElement.getBoundingClientRect();
    const containerRect = tableContainerRef.current.getBoundingClientRect();
    const scrollX = tableContainerRef.current.scrollLeft;

    // Измеряем размеры будущего тултипа, рендеря его невидимо в DOM.
    const tempTooltip = document.createElement("div");
    tempTooltip.style.cssText = "visibility:hidden;position:absolute;padding:9px 12px;font-size:13px;line-height:1.55;max-width:230px;font-family:Inter,-apple-system,system-ui,'Segoe UI',Roboto,Arial,sans-serif;";
    tempTooltip.innerHTML = text?.replace(/\n/g, "<br/>") || text;
    document.body.appendChild(tempTooltip);
    const tooltipWidth = tempTooltip.offsetWidth;
    const tooltipHeight = tempTooltip.offsetHeight;
    document.body.removeChild(tempTooltip);

    // Базовая позиция — НАД ячейкой, центр по горизонтали.
    let x = rect.left - containerRect.left + scrollX + (rect.width - tooltipWidth) / 2;
    let y = rect.top - containerRect.top - tooltipHeight - 10;

    const containerWidth = tableContainerRef.current.offsetWidth;

    // Не вылезаем за границы контейнера по горизонтали.
    if (x < 6) x = 6;
    if (x + tooltipWidth > containerWidth - 6) {
      x = containerWidth - tooltipWidth - 6;
    }
    // Если не помещается сверху — кладём под ячейку.
    if (y < 0) {
      y = rect.bottom - containerRect.top + 10;
    }

    setTooltip({ visible: true, text, x, y });
    if (tooltipRef.current) tooltipRef.current.targetElement = targetElement;
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, text: "", x: 0, y: 0 });
    if (tooltipRef.current) tooltipRef.current.targetElement = null;
  };

  return { tooltip, handleMouseEnter, handleMouseLeave, tableContainerRef, tooltipRef };
};

export default useTooltipLogic;